<template>
    <div class="h-screen w-screen mx-auto container max-w-5xl p-4 md:p-0">
        <div class="flex flex-wrap justify-center items-center">
            <div class="w-full md:w-1/2 mt-12">
                <ul class="socials flex flex-wrap justify-between mb-4">
                    <li class="flex-1 mt-1">
                        <a href="https://www.nohrahaimegallery.com/" target="_nohra">
                        <img src="/images/NHGLogo-trans.png" class="w-20 inline-block -mt-[2px] pr-2" alt="Nora Haime Gallery"/>Nohra Haime Gallery</a>
                    </li>
                    <li class="w-1/10"><a href="https://www.linkedin.com/profile/view?id=AAIAAANbhCIB9cyjUvqWe6nOclMUHFLkuFjxefc&amp;trk=nav_responsive_tab_profile_pic"><img src="/images/socials/webicon-linkedin.svg" alt="LinkedIn" width="35" height="35" border="0"></a></li>
                    <li class="w-1/10"><a href="https://www.facebook.com/valerieb.hird"><img src="/images/socials/webicon-facebook.svg" alt="Facebook" width="35" height="35" border="0"></a></li>
                    <li class="w-1/10"><a href="http://instagram.com/valeriehird?ref=badge"><img src="/images/socials/webicon-instagram.svg" alt="Instagram" width="35" height="35" border="0"></a></li>
                    <li class="w-1/10"><a href="https://vimeo.com/valeriehird"><img src="/images/socials/webicon-vimeo.svg" alt="Instagram" width="35" height="35" border="0"></a></li>
                </ul>
                <ContactForm />
            </div>
            <ul class="credits w-full md:w-1/2 md:min-h-svh flex flex-col justify-center p-0 md:p-4 text-left">
                <li>Photo credits:
                    <ul class="pl-8">
                        <li><a href="https://raymondjack.com">Lindsay Raymondjack</a></li>
                        <li><a href="https://www.markhedden.com">Mark Hedden</a></li>
                        <li><a href="mailto:nerissa@see.me">Nerissa Bardfeld</a></li>
                    </ul>
                </li>
                <li>Web credit:
                    <ul class="pl-8"><li><a href="https://acdubs.com">Adam Wood</a></li></ul></li>

            </ul>
        </div>
        <div class="text-center text-xs">&#169;{{ year }} Valerie Hird.</div>
   </div>
</template>

<script>
import ContactForm from '@/components/ContactForm.vue'
import dayjs from 'dayjs';

export default {
   name: "ContactPage",
   components: { ContactForm },
   computed: {
        year() {
            return dayjs().format('YYYY');
        }
   },
   data() {
       return {

       }
   },
   mounted() {

   },
   methods: {

   }
}
</script>
<style>
.socials li {
    @apply justify-end pr-4;
}
.credits li {
    @apply py-1;
}
</style>
